import axios from "axios";


export const api = axios.create({
  baseURL: "/api"
});

api.interceptors.request.use(config => {
  const method = config.method?.toUpperCase();
  if (method && !["GET", "HEAD", "OPTIONS"].includes(method)) {
    const token = document.querySelector<HTMLInputElement>('input[name="__RequestVerificationToken"]')?.value;
    if (token) {
      config.headers.set("RequestVerificationToken", token);
    }
  }

  return config;
});


// This interceptor handles responses globally, checking for errors and formatting them consistently.
// you still have to handle errors in individual requests as needed.
api.interceptors.response.use(
  response => response,
  error => {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      const statusText = error.response?.statusText;
      
      return Promise.reject(new Error(`Request failed: ${status} ${statusText}`));
    }
    return Promise.reject(new Error(`Unexpected error: ${error instanceof Error ? error.message : String(error)}`));
  }
);